exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".clickable__clickable__1fD9z{display:-ms-flexbox;display:flex}", "", {"version":3,"sources":["/home/builduser/agent07/work/c8e02a04a4ed599f/src/shared/containers/clickable/src/shared/containers/clickable/clickable.styl","/home/builduser/agent07/work/c8e02a04a4ed599f/src/shared/containers/clickable/clickable.styl"],"names":[],"mappings":"AAEA,6BACE,oBAAA,YAAA,CCDD","file":"clickable.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.clickable\n  display flex\n",".clickable {\n  display: flex;\n}\n/*# sourceMappingURL=src/shared/containers/clickable/clickable.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"clickable": "clickable__clickable__1fD9z"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/shared/containers/clickable/clickable.styl
// module id = 2554
// module chunks = 1